// Navigation items for BASIC project

import {
  MessagesIcon,
  StoresIcon,
} from '../../components/MainNavigation/icons'

/**
 * Get navigation items for BASIC project
 * @param {Object} context - Context object with location, t, newMessagesCount
 * @returns {Array} Array of navigation items
 */
export const getBASICNavigationItems = (context) => {
  const { location, t, newMessagesCount = {} } = context

  const printMessagesCount = (count) => {
    if (count) {
      return count
    }
    return null
  }

  return [
    {
      url: '/messages',
      label: t('menu.messages'),
      icon: () => <MessagesIcon selected={location.pathname.startsWith('/messages')} />,
      badge: printMessagesCount(newMessagesCount.messages),
      selected: location.pathname.startsWith('/messages'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/integrations',
      label: t('menuEinvoice.integrations'),
      icon: () => <StoresIcon selected={location.pathname.startsWith('/integrations')} />,
      badge: printMessagesCount(newMessagesCount.sites),
      selected: location.pathname.startsWith('/integrations'),
      isTaxAgentMainVisible: false,
    },
  ]
}
